import CaseTypes from 'casetypes/case-types';
import NavPanel from 'nav-panel/nav-panel';
import Pcodes from 'pcodes/components/pcodes';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useGetUserContextQuery } from 'services/user-context/user-context-api';
import styled from 'styled-components';
import NotFoundPage from 'ui/error-pages/not-found-page';
import { canAccessCaseTypes, canAccessPCodes } from 'utils/role-conditions';
import ProtectedRoute from './protected-route';

const Wrapper = styled.main`
  min-height: calc(100% - 97px);
  height: calc(100% - 97px);
  position: relative;
  margin: 0 auto;
  font-family: 'Roboto';
`;

const Body = () => {
  const { data: userContext } = useGetUserContextQuery();

  return (
    <Wrapper>
      <Switch>
        <Redirect exact from="/" to="/overview" />
        <Route exact path="/overview" component={NavPanel} />
        <ProtectedRoute
          condition={canAccessCaseTypes(userContext?.roles)}
          component={CaseTypes}
          path="/case-types"
        />
        <ProtectedRoute
          condition={canAccessPCodes(userContext?.roles)}
          component={Pcodes}
          path="/pcodes"
        />
        <Route component={NotFoundPage} />
      </Switch>
    </Wrapper>
  );
};

export default Body;
